import { createSlice } from '@reduxjs/toolkit'

const initialInspectionCompanyState = {
  inspectionCompany: null,
  inspectionCompaniesDropdown: null,
  plansDropdown: [],
}

export const InspectionCompanySlices = createSlice({
  name: 'inspectionCompanies',
  initialState: initialInspectionCompanyState,
  reducers: {
    inspectionCompany: (state, action) => {
      state.inspectionCompany = action.payload.inspection_company
    },
    inspectionCompaniesList: (state, action) => {
      state.inspectionCompaniesDropdown = action.payload.inspection_companies
    },
    inspectionCompaniesPlanList: (state, action) => {
      state.plansDropdown = action.payload.subscription_plans
    }
  },
})